import './Encrypted.module.scss'

import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import hotelSetupApi from 'services/api/hotelSetup'

import ConfirmationDialog from '../../components/ReusableComponents/ConfirmationDialog/index'
// eslint-disable-next-line
import Encrypted from './Encrypted'
import styles from './Onboarding.module.scss'
import PmsCredentialForm from './PmsCredentialForm'
import PmsStatus from './PmsStatus'

function generateCredentialString(username, password, propertyId) {
  if (propertyId) {
    return `${username}|||${password}|||${propertyId}`
  }

  return `${username}|||${password}`
}

const InitialStep = ({ currentPms, handleSubmit }) => (
  <div>
    <div className={styles.warning}>
      <p className={styles.title}>Never enter your GM password here.</p>
      <p className={styles.p}>Password will be changed automatically</p>
    </div>
    <div className={styles.container}>
      <PmsCredentialForm pms={currentPms} onSave={handleSubmit} />
      <div className={styles.flexContainer}>
        <Encrypted />
      </div>
    </div>
  </div>
)

const Onboarding = () => {
  const currentPms = useSelector(s => s.login.subsidiaryPMS)
  const currentHotelId = useSelector(s => s.login.currentHotelId)

  const [showLoadingDialog, setShowLoadingDialog] = useState()
  const [showOverWriteDialog, setShowOverWriteDialog] = useState(false)

  const [lastPropertyId, setLastPropertyId] = useState()
  const [lastUserName, setLastUserName] = useState()
  const [lastPassword, setLastPassword] = useState()

  const { addToast } = useToasts()

  const [passwordChangeStatus, setPasswordChangeStatus] = useState(null)

  function statusCheck() {
    hotelSetupApi.pmsSyncStatus().then(res => {
      if (res.isManuallyProvidedPasswordChanged === null) {
        setTimeout(() => {
          statusCheck()
        }, 1000)
      } else {
        setPasswordChangeStatus(res.isManuallyProvidedPasswordChanged)
        setShowLoadingDialog(false)

        if (res.isManuallyProvidedPasswordChanged) {
          addToast(`Succesfuly changed the password`, {
            appearance: 'success',
            autoDismiss: false
          })
        } else {
          addToast(`Failed to change the password`, {
            appearance: 'error',
            autoDismiss: false
          })
        }
      }
    })
  }

  function handleSubmit(userName, password, propertyId) {
    setLastUserName(userName)
    setLastPassword(password)
    setLastPropertyId(propertyId)

    const credentialString = generateCredentialString(userName, password, propertyId)

    hotelSetupApi
      .tryLogin({ hotelId: currentHotelId, credentialString })
      .then(() => {
        setShowLoadingDialog(true)
        statusCheck()
      })
      .catch(err => {
        if (err.toString().includes('do you want to overwrite')) {
          setShowOverWriteDialog(true)
        } else {
          setShowLoadingDialog(false)
          addToast(`Something went wrong: ${err.toString()}`, {
            appearance: 'error',
            autoDismiss: false
          })
        }
      })
  }

  function confirmOverwriteCredentials() {
    setShowOverWriteDialog(false)
    setShowLoadingDialog(true)

    const credentialString = generateCredentialString(
      lastUserName,
      lastPassword,
      lastPropertyId
    )

    hotelSetupApi
      .tryLogin({
        hotelId: currentHotelId,
        credentialString,
        IsOverwriteExistingCredentials: true
      })
      .then(() => {
        setShowLoadingDialog(true)
        statusCheck()
      })
  }

  if (showOverWriteDialog) {
    return (
      <ConfirmationDialog
        title="Existing credentials found"
        positiveMessage="Yes, overwrite"
        negativeMessage="No, cancel"
        onReject={() => setShowOverWriteDialog(false)}
        onConfirm={() => confirmOverwriteCredentials()}
      >
        <p style={{ fontSize: 14 }}>
          PMS already has credentials, do you want to overwrite them?
        </p>
      </ConfirmationDialog>
    )
  }

  if (showLoadingDialog) {
    return <PmsStatus passwordChangeStatus={passwordChangeStatus} />
  }

  return <InitialStep currentPms={currentPms} handleSubmit={handleSubmit} />
}

export default Onboarding
